/**
 * Patří tenhle toast do historie oznámení?
 *
 * `operation-feedback` u volání delších než 800 ms bez vlastního popisku
 * použije jako titulek JMÉNO NÁSTROJE (`label = opts.label ?? toolName`).
 * Takový toast je pro člověka smysluplný jen v tu vteřinu, kdy svítí — do
 * historie zapíše identifikátor, ne zprávu. Na acm-dev tím napršelo přes 63 000
 * záznamů „notifications.list" a 36 000 „docker.container_list" a překlad na tom
 * nemá co dělat: nejde o větu (Filip 2026-09-09: „ten překlad na ty logy
 * nefunguje").
 *
 * Filtruje se podle TVARU, ne podle seznamu jmen: `modul.akce` nebo
 * `modul_akce` bez mezer je identifikátor. Skutečná hláška má mezeru nebo
 * diakritiku a projde.
 */
const TOOL_NAME = /^[a-z][a-z0-9-]*[._][a-z0-9_.-]+$/;

export function isLoggableToastTitle(title: string): boolean {
  const value = title.trim();
  if (!value) return false;
  // Mezera = věta, ne identifikátor. Rozhoduje dřív než tvar jména.
  if (/\s/.test(value)) return true;
  return !TOOL_NAME.test(value);
}
